import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getFilaEsperaAgenda(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada. Entre novamente no sistema.");
        ApiService.setHeader();
        let data;
        try {
            ({ data } = await ApiService.postOnce("filasEsperaAgenda/access/listar", dados));
        } catch (error) {
            const mensagem = error.response?.data?.msg || error.response?.data?.erro;
            throw new Error(typeof mensagem === "string" && mensagem.trim()
                ? mensagem : "Não foi possível consultar a fila de espera. Tente novamente.");
        }
        if (!Array.isArray(data)) {
            const mensagem = data?.msg || data?.erro;
            throw new Error(typeof mensagem === "string" && mensagem.trim()
                ? mensagem : "Não foi possível consultar a fila de espera. Tente novamente.");
        }
        return data;
    }, 
    postFilaEsperaAgenda(context, dados) {
      return new Promise(resolve => {
          if(JwtService.getToken()) {
              ApiService.setHeader();
              ApiService.post("filasEsperaAgenda/access/salvar", dados).then(({ data }) => {
                  resolve(data);
              });
          }
      });
    }, 
    excluirFilaEsperaAgenda(context, dados) {
      return new Promise(resolve => {
          if(JwtService.getToken()) {
              ApiService.setHeader();
              ApiService.post("filasEsperaAgenda/access/excluir", dados).then(({ data }) => {
                  resolve(data);
              });
          }
      });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
